// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"VFBB-ATWCvELPo6aVP7k_"};